const maxValueFromFB = (pickedVal) => {
  if (typeof (pickedVal) === 'object') {
    const keysWithFb = Object?.keys(pickedVal)?.filter((key) => key.includes('fb'));
    const largestNumber = Math?.max(...keysWithFb.map((key) => pickedVal[key]));
    return largestNumber;
  }
  return 0;
}; export default maxValueFromFB;
